import { audioObjectsOverviewRoute } from 'pages/NWPlatform/Workspaces/Workspace/Audio/Objects'
import { audioStreamObjectsOverviewRoute } from 'pages/NWPlatform/Workspaces/Workspace/Audio/Streams/Stream'

export type SortableHeaderRoute = 'objects' | 'streams'

export const useSortableHeaderRoute = (route: SortableHeaderRoute) => {
  if (route === 'objects') {
    return audioObjectsOverviewRoute
  } else {
    return audioStreamObjectsOverviewRoute
  }
}
